import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";

function Splash() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-ink" data-testid="auth-loading">
      <div className="animate-pulse">
        <Brand size="lg" />
      </div>
    </div>
  );
}

export function ProtectedRoute() {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Splash />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return <Outlet />;
}

export function PublicOnlyRoute() {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  if (user) return <Navigate to="/" replace />;
  return <Outlet />;
}

export function OwnerRoute() {
  const { user } = useAuth();
  if (user?.role !== "owner") return <Navigate to="/" replace />;
  return <Outlet />;
}
